export default [
  { value: "FEMALE", key: "gender.female" },
  { value: "MALE", key: "gender.male" },
  { value: "N/D", key: "gender.nd" },
];



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/members/enums/genders.js